import { useTheme } from "../../framework/theme/mantine-passthroughs.js";
import { rem } from "../../framework/theme/util/misc.js";
import "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/icon/Icon.tsx
const DEFAULT_VARIANT = "rounded";
const Icon = ({ color = "currentColor", style = {}, SvgIcon, height = rem("24px"), width = rem("24px"), alt, "data-testid": testId = "icon" }) => {
	return /* @__PURE__ */ jsx(SvgIcon, {
		fill: useTheme().other.getIconColor(color),
		style: {
			...style,
			height,
			width,
			minHeight: height,
			minWidth: width
		},
		"data-testid": testId,
		"aria-label": alt
	});
};

//#endregion
export { DEFAULT_VARIANT, Icon };